import { createMuiTheme } from "@material-ui/core";
// import { blue } from '@material-ui/core/colors';

// typographyの参考 https://material-ui.com/style/typography/#migration-to-typography-v2
export const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    // primary: blue,
    // secondary: {
    //   main: '#283593',
    // },
    // primary: {
    //   // light: will be calculated from palette.primary.main,
    //   // main: cyan['50'] //'#ff4400',
    //   // dark: will be calculated from palette.primary.main,
    //   // contrastText: will be calculated to contrast with palette.primary.main
    // },
    // secondary: {
    //   light: '#0066ff',
    //   main: cyan['500'], // '#ff44ff',
    //   // dark: will be calculated from palette.secondary.main,
    //   contrastText: '#00cc00',
    // },
    // error: will use the default color
  }
});
/*
  palette: {
    // // alternateTextColor: black,
    canvasColor: cyan50,
    accent1Color: cyan500,
    primary1Color: cyan900
  } });

*/


// WEBPACK FOOTER //
// ./src/material-ui/theme.tsx